import { QuestionCircleOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';
import { useContext, useMemo } from 'react';

import { VendorLeadStepGuide } from 'src/components/vendors/steps/VendorLeadStepGuide';
import { VendorsContext } from 'src/pages/VendorsPage/VendorsPage.context';

type VendorLeadGuideMobileProps = {
  className?: string;
};

export function VendorLeadGuideMobile({ className }: Readonly<VendorLeadGuideMobileProps>) {
  const { vendorStepGuideKey, vendorLeadProductSpecification, isMobileGuideOpened, toggleMobileGuideOpened } =
    useContext(VendorsContext);

  const isGuideAvailable = useMemo(
    () => !!vendorStepGuideKey && !!vendorLeadProductSpecification?.fieldGroupGuides[vendorStepGuideKey],
    [vendorStepGuideKey, vendorLeadProductSpecification?.fieldGroupGuides]
  );

  if (!isGuideAvailable) {
    return null;
  }

  return (
    <div className={className}>
      <Drawer open={isMobileGuideOpened} placement="right" onClose={toggleMobileGuideOpened} destroyOnClose={false}>
        <VendorLeadStepGuide />
      </Drawer>
      <Button type="link" icon={<QuestionCircleOutlined />} onClick={toggleMobileGuideOpened} />
    </div>
  );
}
